
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const whatsappNumber = "5541997929641";
  const message = "Olá! Gostaria de saber mais sobre os serviços de filmagem aérea da Skyview.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#111111]/95 backdrop-blur-sm">
      <div className="px-6 py-4">
        <nav className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/1bcf13b5daffa6303a7ae256b0b51ed5.png" 
              alt="Skyview - A sua marca vista do céu" 
              className="h-24 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#portfolio" className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide">
              Portfólio
            </a>
            <a href="#servicos" className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide">
              Serviços
            </a>
            <a href="#sobre" className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide">
              Sobre
            </a>
            <a href="#orcamento" className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide">
              Orçamento
            </a>
            
            {/* WhatsApp Button */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] hover:bg-[#20b358] text-white px-4 py-2 rounded-full shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer flex items-center space-x-2"
              aria-label="Fale conosco no WhatsApp"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              <span className="text-sm font-medium whitespace-nowrap">WhatsApp</span>
            </a>
            
            <div className="text-[#A2AEAB] text-sm">©2025</div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-[#C0C0C0] transition-colors"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-[#A2AEAB]/20">
            <div className="flex flex-col space-y-4 pt-4">
              <a 
                href="#portfolio" 
                className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide"
                onClick={() => setIsMenuOpen(false)}
              >
                Portfólio
              </a>
              <a 
                href="#servicos" 
                className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide"
                onClick={() => setIsMenuOpen(false)}
              >
                Serviços
              </a>
              <a 
                href="#sobre" 
                className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide"
                onClick={() => setIsMenuOpen(false)}
              >
                Sobre
              </a>
              <a 
                href="#orcamento" 
                className="text-white hover:text-[#C0C0C0] transition-colors duration-300 tracking-wide"
                onClick={() => setIsMenuOpen(false)}
              >
                Orçamento
              </a>
              
              {/* Mobile WhatsApp Button */}
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] hover:bg-[#20b358] text-white px-4 py-2 rounded-full shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer flex items-center justify-center space-x-2 w-fit"
                aria-label="Fale conosco no WhatsApp"
              >
                <i className="ri-whatsapp-fill text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">WhatsApp</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
